import axios from 'axios';
import { objectToParam } from '../util/helper';

export const apiGet = (params: object) => {
  return axios.get(
    `https://ceasmarketplace.com/wp-admin/admin-ajax.php?${objectToParam(params)}`
  );
};

export const apiPost = (params: object) => {
  const formData = new FormData();
  Object.keys(params).forEach((key) => formData.append(key, (params as any)[key]));
  return axios.post(`https://ceasmarketplace.com/wp-admin/admin-ajax.php`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default (userId: any) => {
  return axios.create({
    headers: { user_id: userId },
  });
};
